import { writable } from "svelte/store";
export let currentQuote = writable({});
export let loading = writable(false);
export let isShareOpen = writable(false);
export let isDownloadOpen = writable(false);
export let theme = writable("dark");
